import animation from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: block;
  user-select: none;

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    place-content: center;
    place-items: center;
    width: 100%;

    li {
      display: inline-block;
      opacity: 1;
      transition: opacity 0.15s ease-out;
      padding: 0 3px;

      @media ${from(Device.Tablet)} {
        padding: 0 5px;
      }

      a,
      span {
        display: flex;
        background-color: ${rgba(brand.white, 0)};
        border-radius: 1000000px;
        font-feature-settings: 'tnum' on;
        font-size: 16px;
        line-height: 20px;
        margin: 0;
        height: 30px;
        place-content: center;
        place-items: center;
        transition: background-color 0.15s ${animation.secondary};
        width: 30px;

        @media ${from(Device.TabletLarge)} {
          height: 40px;
          width: 40px;
          font-size: 22px;
          line-height: 32px;
        }
      }

      a {
        cursor: pointer;
        ${fonts.matter.regular};

        &:focus {
          outline: none;
        }

        &:hover {
          background-color: ${brand.sage.sageLight};
          color: ${brand.white};
        }

        @supports selector(:focus-visible) {
          &:focus-visible {
            background-color: ${brand.sage.sageLight};
            color: ${brand.white};
          }
        }

        @supports not selector(:focus-visible) {
          &:focus {
            background-color: ${brand.sage.sageLight};
            color: ${brand.white};
          }
        }
      }

      &.previous,
      &.next {
        text-indent: -100vw;

        &:focus {
          background-color: ${brand.sage.sageMedium};
        }
        

        a {
          background-color: ${brand.sage.sageDark};
          border-radius: 1000000px;

          &:focus,
          &:hover {
            background-color: ${brand.sage.sageLight};
          }
        }

        svg {
          display: block;
          height: 26px;
          width: 26px;
          color: ${brand.white};
        }
      }

      &.previous {
        padding-right: 10px;

        @media ${from(Device.Tablet)} {
          padding-right: 15px;
        }
      }

      &.next {
        padding-left: 10px;

        @media ${from(Device.Tablet)} {
          padding-left: 15px;
        }
      }

      &.selected {
        a {
          background: ${rgba(brand.sage.sageDark, 1)};
          border-radius: 1000000px;
          color: ${brand.white};

          &:hover {
            background-color: ${brand.sage.sageLight};
            color: ${brand.white};
          }

          @supports selector(:focus-visible) {
            &:focus-visible {
              background-color: ${brand.sage.sageLight};
              color: ${brand.white};
            }
          }

          @supports not selector(:focus-visible) {
            &:focus {
              background-color: ${brand.sage.sageLight};
              color: ${brand.white};
            }
          }
        }
      }

      &.disabled {
        cursor: default;
        opacity: 0.5;
        pointer-events: none;

      }
    }
  }
`;
export default {
    Wrapper,
};
